import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

export function setupProfile(): void {

  applicationModuleRegistry.register({
    entry: 'profile',
    id: 'profile',
    name: 'result.profile',
    route: APPLICATION_ROUTES.PROFILE
  });

}
